import { useQuery } from "react-query";
import axios from "infra/http";
import { TransferenciaDetalhesResponse } from "../typings";

function useFindTransferenciaConta(id: string | undefined) {
  return useQuery(
    `v1/transferencia/${id}/detalhes`,
    async () => {
      const { data } = await axios.get<TransferenciaDetalhesResponse>(
        `v1/transferencia/${id}/detalhes`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useFindTransferenciaConta;
